<template>
  <div>
    <a ref="lienDownload"></a>
    <v-client-table
      ref="tableListe"
      :data="reseauxWithFilter"
      :columns="columns"
      :options="options"
      @filter="tableIsFilter">
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input type="checkbox" id="checkbox" :value="props.row" v-model="props.row.selected"
               @click="ajoutPanier(props.row)">
      </div>
      <div slot="nbFaces" slot-scope="props">
        <div class="is-pulled-right">{{props.row.nbFaces}}</div>
      </div>
      <div slot="tarifBrut" slot-scope="props">
        <div class="is-pulled-right">{{props.row.tarifBrutString}}</div>
      </div>
      <div slot="dureeConservation" slot-scope="props">
        <div class="is-pulled-right">{{props.row.dureeConservation}}</div>
      </div>
      <div slot="depCode" slot-scope="props">
        <div class="is-pulled-right">{{props.row.depCode}}</div>
      </div>
      <div slot="selected" slot-scope="props">
        <input class="checkbox-disabled" type="checkbox" disabled :checked="props.row.selected">
      </div>
      <div slot="zoom" slot-scope="props" style="text-align:center">
        <a @click="zoomReseau(props.row)">
          <b-icon icon="google-maps" type="is-primary"></b-icon>
        </a>
      </div>
      <div slot="diaporama" slot-scope="props" style="text-align:center">
        <a @click="ouvrirDiaporama(props.row)">
          <b-icon icon="image-multiple" type="is-primary"></b-icon>
        </a>
      </div>
      <div slot="downloadPDF" slot-scope="props" style="text-align:center">
        <a @click="download(props.row)">
          <b-icon icon="file-pdf" type="is-danger"></b-icon>
        </a>
      </div>
      <div slot="colorPicker" slot-scope="props" style="text-align:center">
        <color-marker
          v-model="props.row.couleur"
          @input="colorsPickerChange(props.row)"/>
      </div>
    </v-client-table>

    <b-modal v-model="isComponentOuvrirListeFaces"
             has-modal-card
             class="modal modal-liste-faces">
      <app-consultation-carte :reseau="reseau" :disabled="disabled"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as types from '@/store/creationOpportunite/venteReseauxNumerique-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import colorMarker from '@/components/general/colorMarker';
import gestionErreur from '@/services/general/gestionErreur';
import { getFicheReseauxNumerique } from '@/api/reseauxNumerique';
import ConsultationCarte from './consultation/carte_reseau_num';

const VenteReseauxNumerique = createNamespacedHelpers('venteReseauxNumerique');
const Modal = createNamespacedHelpers('modal');
const Panier = createNamespacedHelpers('panier');

export default {
  name: 'liste',
  components: {
    colorMarker,
    appConsultationCarte: ConsultationCarte,
  },
  data() {
    return {
      refDropDown: 'refDropDown',
      trad: {
        libelle: '↑↓ Libelle',
        depCode: '↑↓ Dept.',
        ville: '↑↓ Ville',
        nbFaces: '↑↓ Nb Faces prévues ',
        confrere: '↑↓ Confrère',
        format: '↑↓ Format',
        tarif: '↑↓ Tarif brut',
        tempsConservation: '↑↓ Durée (semaine)',
        selected: '',
        jourDepartLibelle: '↑↓ Départ',
        colorPicker: 'Couleur',
        addPanier: 'Panier',
        zoom: 'Carto',
        code: '↑↓ Code',
        type: '↑↓ Type',
        diaporama: 'Diapo',
        downloadPDF: 'PDF',
      },
      checked: [],
      dataProposition: {},
      reseau: null,
      isComponentOuvrirListeFaces: false,
      disabled: true,
      isFiltred: false,
    };
  },
  watch: {},
  computed: {
    ...VenteReseauxNumerique.mapGetters({
      showReseaux: 'showReseaux',
      reseauxWithFilter: 'reseauxWithFilter',
      markersReseaux: 'markersReseaux',
      dateDeVisualisation: 'dateDeVisualisation',
      getActiveTabReseau: 'activeTabReseau',
      getZoomMarker: 'zoomMarker',
    }),
    ...Panier.mapGetters({
      reseauxTempoPanier: 'reseauxTempoPanier',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesReseauSelect: 'facesSelectDiapo',
    }),
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    activeTab: {
      get() {
        return this.getActiveTabReseau;
      },
      set(value) {
        this.setActiveTabReseau(value);
      },
    },
    zoomMarker: {
      get() {
        return this.getZoomMarker;
      },
      set(value) {
        this.setZoomMarker(value);
      },
    },
    columns() {
      return ['selected', 'code', 'libelle', 'depCode', 'ville', 'nbFaces', 'type', 'confrere', 'format', 'tarifBrut', 'dureeConservation', 'jourDepartLibelle', 'zoom', 'diaporama', 'downloadPDF', 'colorPicker'];
    },
    options() {
      return {
        headings: {
          selected: this.trad.selected,
          libelle: this.trad.libelle,
          depCode: this.trad.depCode,
          ville: this.trad.ville,
          nbFaces: this.trad.nbFaces,
          confrere: this.trad.confrere,
          format: this.trad.format,
          tarifBrut: this.trad.tarif,
          dureeConservation: this.trad.tempsConservation,
          jourDepartLibelle: this.trad.jourDepartLibelle,
          colorPicker: this.trad.colorPicker,
          addPanier: this.trad.addPanier,
          zoom: this.trad.zoom,
          code: this.trad.code,
          type: this.trad.type,
          diaporama: this.trad.diaporama,
          downloadPDF: this.trad.downloadPDF,
        },
        filterByColumn: true,
        filterable: ['code', 'libelle', 'depCode', 'ville', 'type', 'confrere'],
        perPageValues: PER_PAGE_VALUE,
        perPage: 99999,
        texts: TEXTS,
        columnsClasses: {
          format: 'ellipsis ventesReseauxListeTailleColonneFormat',
          libelle: 'ellipsis ventesReseauxListeTailleColonneLibelle',
          ville: 'ellipsis ventesReseauxListeTailleColonneVille',
          confrere: 'ellipsis ventesReseauxListeTailleColonneConfrere',
          type: 'ellipsis ventesReseauxListeTailleColonneType',
          jourDepartLibelle: 'ellipsis ventesReseauxListeTailleColonnejourDepartLibelle',
        },
        customSorting: {
          jourDepartLibelle(ascending) {
            return (a, b) => {
              if (ascending) {
                return a.jourDepart >= b.jourDepart ? 1 : -1;
              }
              return a.jourDepart <= b.jourDepart ? 1 : -1;
            };
          },
        },
      };
    },
  },
  methods: {
    ...VenteReseauxNumerique.mapMutations({
      setReseauxWithFilter: types.SET_RESEAUX_WITH_FILTER,
      setActiveTabReseau: types.SET_ACTIVE_TAB_RESEAU,
      setZoomMarker: types.SET_ZOOM_MARKER,
    }),
    ...VenteReseauxNumerique.mapActions({
      actionUpdateMarkerReseaux: 'updateMarkerReseau',
      actionsEnvoyerCouleurReseau: 'envoyerCouleurReseau',
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    ouvrirDiaporama(reseau) {
      reseau.listeFaces.forEach((el) => {
        el.libelleReseau = reseau.libelle;
      });
      this.facesReseauSelectDiapo = reseau.listeFaces;
      this.isComponentDiaporama = true;
    },
    zoomReseau(reseau) {
      this.reseau = reseau;
      this.isComponentOuvrirListeFaces = true;
    },
    async colorsPickerChange(reseau) {
      const index = this.reseauxWithFilter.findIndex(el => el.num === reseau.num);
      this.reseauxWithFilter[index].couleur = reseau.couleur;
      this.setReseauxWithFilter(this.reseauxWithFilter);
      await this.actionsEnvoyerCouleurReseau({ reseau: reseau, couleur: reseau.couleur });
    },
    async download(produit) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const response = await getFicheReseauxNumerique(produit);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        gestionErreur(`Erreur lors de l'impression de la fiche du panneau Lc n°${produit.num}`, e);
      }
      loadingComponent.close();
    },
    tableIsFilter() {
      this.$emit('liste', {
        data: this.$refs.tableListe.filteredData,
        type: 'reseauxNum',
      });
    },
  },
  mounted() {
    this.tableIsFilter();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/recherche/liste.vue